import script from "./TenderCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TenderCard.vue?vue&type=script&setup=true&lang=js"

import "./TenderCard.vue?vue&type=style&index=0&id=65f36dd9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65f36dd9"]])

export default __exports__